import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Typography,
} from "@material-tailwind/react";
import { bankDetailFields } from "../nfcCardConstants";
import NfcAccountCard from "./NfcAccountCard";
import NfcCardPay from "./NfcCardPay";

const amount = 150;

const statusLabel = {
  processing: "Processing",
  ready: "Ready",
  completed: "Completed",
};

const hasCompleteBankDetails = (application) =>
  bankDetailFields.every((field) => application?.[field]?.trim());

function NfcApplicationSummaryCard({
  application,
  isInGoodStanding,
  autoPayCardId,
  onEdit,
  onAutoPayReset,
}) {
  return (
    <Card key={application.id} className="mb-6">
      <CardBody>
        <Typography variant="h5" color="black">
          NFC Identification Card Application
        </Typography>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 my-4">
          <div>
            <span>Ghana Card Number</span>
            <Typography variant="h6" color="black">
              {application.ghana_card_number}
            </Typography>
          </div>
          <div>
            <span>Amount</span>
            <Typography variant="h6" color="black">
              GH¢ {application.amount || amount}
            </Typography>
          </div>
          <div>
            <span>Payment</span>
            <Typography variant="h6" color="black">
              {application.paid === 1 ? "Paid" : "Not Paid"}
            </Typography>
          </div>
          <div>
            <span>Status</span>
            <Typography variant="h6" color="black">
              {application.paid === 1
                ? statusLabel[application.status] || application.status
                : "Please make payment"}
            </Typography>
          </div>
          <div>
            <span>Marital Status</span>
            <Typography variant="h6" color="black">
              {application.marital_status || "Not provided"}
            </Typography>
          </div>
          <div>
            <span>GPS Address</span>
            <Typography variant="h6" color="black">
              {application.gps_address || "Not provided"}
            </Typography>
          </div>
          <div>
            <span>Next of Kin</span>
            <Typography variant="h6" color="black">
              {application.next_of_kin_name || "Not provided"}
            </Typography>
          </div>
          <div>
            <span>Next of Kin Contact</span>
            <Typography variant="h6" color="black">
              {application.next_of_kin_contact || "Not provided"}
            </Typography>
          </div>
          <div>
            <span>Relationship</span>
            <Typography variant="h6" color="black">
              {application.next_of_kin_relationship || "Not provided"}
            </Typography>
          </div>
        </div>

        {application.status === "completed" && <NfcAccountCard compact />}
      </CardBody>

      {(application.paid === 1 || isInGoodStanding) && (
        <CardFooter className="flex flex-col sm:flex-row gap-3">
          <Button
            type="button"
            color="blue-gray"
            variant="outlined"
            onClick={() => onEdit(application)}
          >
            {application.paid === 1 ? "Update Bank Details" : "Edit Details"}
          </Button>

          {application.paid !== 1 &&
            application.passport_photo &&
            hasCompleteBankDetails(application) && (
              <NfcCardPay
                id={application.id}
                amount={application.amount || amount}
                autoOpen={autoPayCardId === application.id}
                onAutoOpen={onAutoPayReset}
              />
            )}

          {application.paid !== 1 &&
            application.passport_photo &&
            !hasCompleteBankDetails(application) && (
              <Typography variant="small" color="gray">
                Complete the bank account details to enable payment.
              </Typography>
            )}
        </CardFooter>
      )}
    </Card>
  );
}

export default NfcApplicationSummaryCard;
